var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"read-more",domProps:{"innerHTML":_vm._s(_vm.textToDisplay)}}),_vm._v(" "),(_vm.textExtendsLimit)?_c('a',{staticClass:"link is-blue font-semibold cursor-pointer",class:{ 'block mt-lg' : _vm.showFull },on:{"click":_vm.toggle}},[_vm._v("\n        "+_vm._s(_vm.toggleLabel)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }